import { render, staticRenderFns } from "./LichSuDichVuLuuTruList.vue?vue&type=template&id=2f5b6707"
import script from "./LichSuDichVuLuuTruList.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuLuuTruList.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuLuuTruList.vue?vue&type=style&index=0&id=2f5b6707&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports